import { ComponentProps, FC } from 'react';

import cx from 'classnames';

export const FontAwesomeIcon: FC<ComponentProps<'i'>> = (props) => <i {...props} className={cx(props.className)} />;
